import { APIError } from '@models/error/APIError'
import { request } from '../request'
import dayjs from 'dayjs'

export const burnArea = {
  getFromYear: async function (year: number) {
    const result = await request.get('burntArea', {
      params: {
        campaing: year
      }
    })
    if (result.status.toString().startsWith('2')) {
      return result.data
    } else {
      throw new APIError(result.data.message)
    }
  },

  getBurnArea: async function () {
    const actualYear = dayjs().year()
    return this.getFromYear(actualYear)
  },

  getOldCampaings: async function () {
    const actualYear = dayjs().year()
    return this.getFromYear(actualYear - 1)
  }
}
